module.exports = __webpack_public_path__ + "static/media/check-icon.bd65fcb4.svg";